import { useCallback, useMemo, useState } from 'react';
import { useGetVehicleWarrantyInformationQuery } from '../../../../api/endpoints/vehicleWarrantyInformationReport';
import { useLanguage } from '../../../../contexts/LanguageContext';

export default function useVehicleWarrantyInformationReport() {
    const { getCurrentLanguageId } = useLanguage();
    const [lazyParams, setLazyParams] = useState({ first: 0, rows: 10, page: 1 });
    const [hasApplied, setHasApplied] = useState(false);

    const [activeFilters, setActiveFilters] = useState({
        sasiNo: undefined,
        zNumber: undefined
    });

    const queryArgs = useMemo(
        () => ({
            pageNumber: lazyParams.page || 1,
            pageSize: lazyParams.rows || 10,
            sasiNo: activeFilters.sasiNo ? String(activeFilters.sasiNo).trim() : undefined,
            zNumber: activeFilters.zNumber ?? undefined
        }),
        [lazyParams.page, lazyParams.rows, activeFilters]
    );

     const exportParams = useMemo(() => ({
        sasiNo:  activeFilters.sasiNo  ? String(activeFilters.sasiNo).trim() : null,
        zNumber: activeFilters.zNumber ?? null,
        LanguageId: getCurrentLanguageId(),
    }), [activeFilters, getCurrentLanguageId]);

    const { data, isFetching, isLoading, isError, error, refetch } = useGetVehicleWarrantyInformationQuery(queryArgs, {
        skip: !hasApplied
    });

    const items = hasApplied ? (Array.isArray(data?.items) ? data.items : []) : [];
    const totalCount = hasApplied ? data?.totalCount ?? 0 : 0;

    const onPage = (e) => {
        setLazyParams({ first: e.first, rows: e.rows, page: e.page + 1 });
    };

    const applyFilters = useCallback((filters) => {
        setActiveFilters({
            sasiNo: filters.sasiNo ?? undefined,
            zNumber: filters.zNumber ?? undefined

        });
        setLazyParams((p) => ({ ...p, first: 0, page: 1 }));
        setHasApplied(true);
    }, []);

    const resetFilters = useCallback(() => {
        setActiveFilters({
            sasiNo: undefined,
            zNumber: undefined
        });
        setLazyParams((p) => ({ ...p, first: 0, page: 1 }));
        setHasApplied(false);
    }, []);

    return {
        items,
        totalCount,
        isFetching,
        isLoading,
        isError,
        error,
        refetch,
        lazyParams,
        onPage,
        activeFilters,
        applyFilters,
        resetFilters,
        queryArgs,
        hasApplied,
        exportParams
    };
}